import React, { Component } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { UtilService } from 'hay-core-react';

class MercadoPagoWebhookAjuda extends Component {
    state = { visivel: false };

    render() {
        const t = UtilService.traduzir;
        return (
            <>
                <Button
                    type="button"
                    label={t('main.configuracao.mercadopago.webhook.ajuda.abrir')}
                    icon="pi pi-question-circle"
                    outlined
                    onClick={() => this.setState({ visivel: true })}
                />
                <Dialog
                    header={t('main.configuracao.mercadopago.webhook.ajuda.titulo')}
                    visible={this.state.visivel}
                    onHide={() => this.setState({ visivel: false })}
                    style={{ width: 'min(95vw, 1050px)' }}
                >
                    <p className="mt-0">{t('main.configuracao.mercadopago.webhook.ajuda.introducao')}</p>
                    <ol className="line-height-3 pl-4">
                        <li>{t('main.configuracao.mercadopago.webhook.ajuda.passo1')}</li>
                        <li>{t('main.configuracao.mercadopago.webhook.ajuda.passo2')}</li>
                        <li>{t('main.configuracao.mercadopago.webhook.ajuda.passo3')}</li>
                        <li>{t('main.configuracao.mercadopago.webhook.ajuda.passo4')}</li>
                        <li>{t('main.configuracao.mercadopago.webhook.ajuda.passo5')}</li>
                    </ol>
                    <div className="surface-100 border-round p-3 mb-3">
                        <strong>{t('main.configuracao.mercadopago.webhook.ajuda.urlrotulo')}</strong>
                        <code className="block mt-2 overflow-auto">https://hotspot.haysystems.com.br/hay/voucher/mercadopago</code>
                    </div>
                    <img
                        src="/images/webook-mp.png"
                        alt={t('main.configuracao.mercadopago.webhook.ajuda.imagemalt')}
                        className="w-full border-1 surface-border border-round"
                    />
                    <p className="mb-0 mt-3">{t('main.configuracao.mercadopago.webhook.ajuda.final')}</p>
                </Dialog>
            </>
        );
    }
}

export default MercadoPagoWebhookAjuda;
